import { render, staticRenderFns } from "./supplier-pane.vue?vue&type=template&id=1068d88f&scoped=true"
import script from "./supplier-pane.vue?vue&type=script&lang=ts"
export * from "./supplier-pane.vue?vue&type=script&lang=ts"
import style0 from "./supplier-pane.vue?vue&type=style&index=0&id=1068d88f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1068d88f",
  null
  
)

export default component.exports